import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";
import { useAdminGate } from "../../../utils/useAdminGate";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import DetailAccentCard from "../../common/detail/DetailAccentCard";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import DashboardSidebar from "../DashboardSidebar";
import ImageGuidelinesContent from "./ImageGuidelinesContent";

export default function AdminImageGuidelines() {
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const { ready, isAdmin } = useAdminGate();

	useEffect(() => {
		const resize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", resize);
		return () => window.removeEventListener("resize", resize);
	}, []);

	if (!ready) return null;
	if (!isAdmin) return <Navigate to="/login/" replace />;

	return (
		<>
			<Helmet>
				<title>راهنمای عکس‌ها | داشبورد همراهتیم</title>
			</Helmet>
			<div className="flex min-h-screen flex-col justify-between bg-[#F0F6FC]">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className="mx-auto max-w-[1200px] px-4">
							<Breadcrumb
								linkDataList={[
									{ label: "خانه", href: "/" },
									{ label: "داشبورد مدیریت", href: "/dashboard/" },
									{
										label: "راهنمای عکس‌ها",
										href: "/dashboard/image-guidelines/",
									},
								]}
							/>
						</div>
					</div>
					<main
						className={[
							"mx-auto flex w-full max-w-[1200px] gap-5 py-8",
							isDesktop ? "flex-row px-4" : "flex-col p-[10px]",
						].join(" ")}
					>
						<DashboardSidebar isDesktop={isDesktop} />
						<section className="min-w-0 flex-1">
							<DetailAccentCard bodyClassName="p-5 md:p-6">
								<h1 className="font-Vazir-800 text-[22px] text-darkBlue md:text-[24px]">
									راهنمای عکس‌ها
								</h1>
								<p className="mt-2 font-Vazir-400 text-[14px] text-darkBlue/60">
									اندازه‌های پیشنهادی برای تیم محصول و طراحی.
								</p>
								<div className="mt-6">
									<ImageGuidelinesContent />
								</div>
							</DetailAccentCard>
						</section>
					</main>
				</div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
